import { render, staticRenderFns } from "./breadcrumbs.vue?vue&type=template&id=187abc56&scoped=true&"
import script from "./breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./breadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./breadcrumbs.vue?vue&type=style&index=0&id=187abc56&prod&scoped=true&lang=css&"
import style1 from "./breadcrumbs.vue?vue&type=style&index=1&id=187abc56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187abc56",
  null
  
)

export default component.exports